import theme from 'src/theme';

const VIEW_OPTIONS = {
  main: {
    id: 'main',
    displayName: 'Default',
  },
  front: {
    id: 'front',
    displayName: 'Front View',
  },
  right: {
    id: 'right',
    displayName: 'Right View',
  },
  left: {
    id: 'left',
    displayName: 'Left View',
  },
  back: {
    id: 'back',
    displayName: 'Back View',
  },
  zoomIn: {
    id: 'zoomIn',
    displayName: 'Zoom In',
  },
  zoomOut: {
    id: 'zoomOut',
    displayName: 'Zoom Out',
  },
};

const ATTRIBUTE_NAMES = {
  brand: 'brand',
  product: 'product',
  material: 'material',
  color: 'color',
};

const OUTLINE_OPTS = {
  getDefault: () => ({
    lineThickness: Hover.Machete.EdgeHelper.DEFAULT_LINE_THICKNESS,
    includePoints: false,
    color: theme.colors.trueBlack,
  }),
  getFocused: () => ({
    lineThickness: Hover.Machete.EdgeHelper.DEFAULT_LINE_THICKNESS * 2,
    includePoints: true,
    color: theme.colors.red,
  }),
};

const FOCUS_OPTS = {
  getDefault: () => ({
    useOrbit: true,
    duration: 1000, // in ms
    moneyshotConfig: {
      offset: 2.0,
    },
  }),
};

const SEGMENTS_VISIBILITY_OPTS = {
  coloring: false,
  visibleDoorVent: false,
  visibleAll: true,
};

/**
 * PARAMETRIC_TYPES are the names that identify each type of parametric geometry.
 * ModelElements whose geometries are ones that don't just follow the geometric
 * prescription found in the model's data, but that also augment it based on parameters
 * are said to be "parametric geometries".
 */
const PARAMETRIC_TYPES = Hover.Constants.PARAMETRIC_GEOMETRY_TYPES;

/**
 * SECOND_ORDER_DETAIL_ATTRIBUTES_BY_PARAMETRIC_TYPE is a map that classifies by type
 * the attributes of the parametric geometries that support second order detail (not
 * every parametric geometry supports it).
 */
const SECOND_ORDER_DETAIL_ATTRIBUTES_BY_PARAMETRIC_TYPE = {
  [PARAMETRIC_TYPES.WINDOW]:
    Hover.Constants.DEFAULT_POLYHEDRAL_WINDOWS_PARAMETRIC_OPTIONS.attributes,

  [PARAMETRIC_TYPES.SHUTTER]:
    Hover.Constants.DEFAULT_POLYHEDRAL_SHUTTERS_PARAMETRIC_OPTIONS.attributes,

  [PARAMETRIC_TYPES.SLIDING_GLASS_DOOR]:
    Hover.Constants.DEFAULT_POLYHEDRAL_SLIDING_GLASS_DOOR_PARAMETRIC_OPTIONS
      .attributes,
};

/**
 * SECOND_ORDER_DETAIL_PARAMETRIC_TYPES are the names of the parametric types that
 * support second order detail.
 */
const SECOND_ORDER_DETAIL_PARAMETRIC_TYPES = Object.keys(
  SECOND_ORDER_DETAIL_ATTRIBUTES_BY_PARAMETRIC_TYPE,
);

const SECOND_ORDER_DETAIL_FEATURE_FLAG_NAMES_BY_PARAMETRIC_TYPE = {
  [PARAMETRIC_TYPES.WINDOW]: 'useSecondOrderDetailWindowsInDesignPro',
  [PARAMETRIC_TYPES.SHUTTER]: 'useSecondOrderDetailShuttersInDesignPro',
  [PARAMETRIC_TYPES.SLIDING_GLASS_DOOR]:
    'useSecondOrderDetailSlidingGlassDoorsInDesignPro',
};

export default {
  ATTRIBUTE_NAMES,
  FOCUS_OPTS,
  OUTLINE_OPTS,
  PARAMETRIC_TYPES,
  SECOND_ORDER_DETAIL_ATTRIBUTES_BY_PARAMETRIC_TYPE,
  SECOND_ORDER_DETAIL_PARAMETRIC_TYPES,
  SECOND_ORDER_DETAIL_FEATURE_FLAG_NAMES_BY_PARAMETRIC_TYPE,
  SEGMENTS_VISIBILITY_OPTS,
  VIEW_OPTIONS,
};
